import has from 'lodash/has'; // @ts-expect-error

import toposort from 'toposort';
import { split } from 'property-expr';
import Ref from '../Reference';
import isSchema from './isSchema';
export default function sortFields(fields) {
  let excludedEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(_ref => {
    let [a, b] = _ref;
    return "".concat(a, "-").concat(b);
  }));
  function addNode(depPath, key) {
    let node = split(depPath)[0];
    nodes.add(node);
    if (!excludes.has("".concat(key, "-").concat(node))) edges.push([key, node]);
  }
  for (const key in fields) if (has(fields, key)) {
    let value = fields[key];
    nodes.add(key);
    if (Ref.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }
  return toposort.array(Array.from(nodes), edges).reverse();
}